Page invoicePage
	title = "Provisionsrechnung"
	needsAuth = true
	
	hasHeaderAndFooter = false
	Good good
	User buyer
	bool showPrintButton = true
	
	show: string id
		good = await app.goods.fetchById id
		if not good or not good.buyer or (good.state != Sold and good.state != PickedUp) or (good.seller != app.user.id and good.buyer != app.user.id and app.user.userType != Admin)
			app.navigateTo homePage; return
		html.setTitle "{title} {good.Marke} {good.Modell}" + app.titleSuffix
		buyer  = await backend.users.fetchById good.buyer
		// seller = await backend.users.fetchById good.seller
		showPrintButton = true

	printInvoice
		showPrintButton = false
		refresh
		Platform.openPrintDialog
		showPrintButton = true
		refresh

	draw
		if not good or not buyer then return
		string text = app.getText("invoice")
		..replaceAll '{TYP}'	with good.Typ
		..replaceAll '{RECHNUNGSDATUM}'	with good.sellDate.dayMonthNameYearString || "(bitte eintragen)"
		..replaceAll '{RECHNUNGS_NR}'	with good.id
		..replaceAll '{KUNDEN_NR}'	with buyer.id
		..replaceAll '{KAEUFER_FIRMA}'	with buyer.businessName
		..replaceAll '{KAEUFER_VERTRETUNG}'	with "{buyer.firstName} {buyer.lastName}"
		..replaceAll '{KAEUFER_ADRESSE}'	with "{buyer.streetAddress}, {buyer.zipCode} {buyer.city}, {buyer.country}"
		..replaceAll '{KAEUFER_TEL}'	with buyer.phoneNumber
		..replaceAll '{KAEUFER_EMAIL}'	with buyer.email
		..replaceAll '{FAHRZEUG_TITEL}'	with "{good.Marke} {good.Modell}"
		..replaceAll '{ZUSCHLAG_DATUM}'	with good.sellDate.dayMonthNameYearString || "(bitte eintragen)"
		..replaceAll '{VERTRAGS_ID}'	with good.id
		..replaceAll '{KAUFPREIS}'	with good.currentPrice.currencyWithCentsString
		..replaceAll '{PROVISION_SATZ}'	with good.commissionRate.percentageString
		..replaceAll '{PROVISION_NETTO}'	with good.commissionNet.currencyWithCentsString
		..replaceAll '{UST_SATZ}'	with good.commissionVatRate.percentageString
		..replaceAll '{UST_BETRAG}'	with (good.commission - good.commissionNet).currencyWithCentsString
		..replaceAll '{PROVISION_NETTO}'	with good.commissionNet.currencyWithCentsString
		..replaceAll '{PROVISION_BRUTTO}'	with good.commission.currencyWithCentsString
		..replaceAll '{DUE_DATE}'	with good.dueDate.dayMonthNameYearString

		if showPrintButton
			column alignItems:center margin:{16 0 16 0}
				app.button "Drucken", onClick:printInvoice

		div text width:960px

